import { render, staticRenderFns } from "./TarifHeader.vue?vue&type=template&id=b5e5eed6"
import script from "./TarifHeader.vue?vue&type=script&lang=js"
export * from "./TarifHeader.vue?vue&type=script&lang=js"
import style0 from "./TarifHeader.vue?vue&type=style&index=0&id=b5e5eed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports